module.exports = __webpack_public_path__ + "img/titulo-depoimentos.15698ccc.svg";